'use client';

// import { WorkloadMetrics } from './workload-metrics';
import { WorkloadListing } from './workload-listing';

export function WorkloadManagementTab() {
  return (
    <div className='space-y-6'>
      {/* <WorkloadMetrics /> */}
      <WorkloadListing />
    </div>
  );
}
